<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Controle da Agenda</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for>Unidade</label>
                                    <input type="text" class="form-control" v-model="filtros.pesquisa" placeholder="Entre com NOME, CNPJ ou CNES da UNIDADE" @keyup.enter="filtrar" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for>Competência</label>
                                    <select v-model="filtros.distribuicao_id" class="form-control">
                                        <option v-for="(distribuicao, index) in distribuicoes" :value="distribuicao.id" :key="index">{{ distribuicao.data_competencia | competencia }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class>&nbsp;</label>
                                    <button @click="filtrar" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%;">
                                                ID
                                                <span @click="sortByKey('distribuicao_contratos.id')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'distribuicao_contratos.id' ? `fa fa-sort-numeric${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: auto;">
                                                Unidade
                                                <span @click="sortByKey('unidades.nome')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'unidades.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 10%">Ação</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.nome }}</td>
                                            <td>
                                                <router-link tag="button" class="btn btn-success btn-sm" :to="`/distribuicao/controle-atendimentos/visualizar-procedimentos/${item.id}`" title="Agenda de Procedimentos">
                                                    <i style="font-size:12px" class="fa fa-fw fa-list"></i>
                                                </router-link>
                                                <router-link tag="button" class="btn btn-info btn-sm" :to="`/distribuicao/controle-atendimentos/visualizar-subgrupos/${item.id}`" title="Agenda de Subgrupos">
                                                    <i style="font-size:12px" class="fa fa-fw fa-list-alt"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../../Alert"; // Importando componente alert

export default {
    data: () => ({
        distribuicoes: [],
        filtros: {
            distribuicao_id: "",
            pesquisa: "",
            tipo: 1,
            coluna: null,
            ordem: null
        },
        dataTable: {},
        dados: {}
    }),
    mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        // this.filtros.distribuicao_id = this.$route.query.distribuicao_id ? this.$route.query.distribuicao_id : this.filtros.distribuicao_id;
        // this.filtros.tipo = this.$route.query.tipo ? this.$route.query.tipo : "";
        this.getDistribuicoes();
        
    },
    methods: {
        filtrar: function(filtros) {
            this.filtros = { ...this.filtros, ...filtros };
            this.getDataTable();
        },
        sortByKey: function(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            this.$router.push({ query: this.filtros });
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/contratos/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        getDistribuicoes() {
            axios
                .get(`${this.$store.state.serverURI}/api/distribuicao/getAll`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.distribuicoes = response.data;
                    this.filtros.distribuicao_id = this.distribuicoes[0].id;
                    this.getDataTable();
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        page: function(val) {
            this.getDataTable();
        }
    },
    components: { Alert }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?db89dcb8